import {get, post, put} from 'simplifyworks-core-ui';

export const getNewOrganOfferDefaultValues = (successCallback, failCallback) => {
	get('/api/foedus/default-values/organ-offer', successCallback, failCallback);
};

export const getNewOrganRequestDefaultValues = (successCallback, failCallback) => {
	get('/api/foedus/default-values/organ-request', successCallback, failCallback);
};

export const getOrganOfferGuid = (successCallback, failCallback) => {
	get('/api/foedus/organ-offer/guid', successCallback, failCallback);
};

export const getOrganRequestGuid = (successCallback, failCallback) => {
	get('/api/foedus/organ-request/guid', successCallback, failCallback);
};

export const getOrganOfferAttachmentTypeCbIds = (successCallback, failCallback) => {
	get('/api/foedus/organ-offer/attachment-type-cb-ids', successCallback, failCallback);
};

export const getLoggedUserCountry = (successCallback, failCallback) => {
	get('/api/foedus/helpers/current-user-country', successCallback, failCallback);
};

export const getLoggedUserFoedusPerson = (successCallback, failCallback) => {
	get('/api/foedus/helpers/current-user-foedus-person', successCallback, failCallback);
};

export const getCoreNativeCodebooks = (data, successCallback, failCallback) => {
	post('/api/core/codebooks/filter', data, successCallback, failCallback);
};

export const getFoedusRoles = (successCallback, failCallback) => {
	get('/api/foedus/value-filters/foedus-roles', successCallback, failCallback);
};

export const getShowNotificationActionButton = (entryId, successCallback, failCallback) => {
	get('/api/foedus/organ-offer/show-notification-action-button?entryId=' + entryId, successCallback, failCallback);
};

export const getShowMessageActionButton = (entryId, successCallback, failCallback) => {
	get('/api/foedus/organ-offer/show-message-action-button?entryId=' + entryId, successCallback, failCallback);
};

export const getShowGrantAnonymousAccessActionButton = (entryId, successCallback, failCallback) => {
	get('/api/foedus/organ-offer/show-grant-anonymous-access-action-button?entryId=' + entryId, successCallback, failCallback);
};

export const getCoreOrganization = (id) => {
	return new Promise((resolve, reject) => {
		get('/api/core/organizations/' + id, resolve, reject);
	});
};

export const getCoreRole = (id) => {
	return new Promise((resolve, reject) => {
		get('/api/core/roles/' + id, resolve, reject);
	});
};

export const deactivateRegisteredDevice = (data, successCallback, failCallback) => {
	post('/api/foedus/contacts/registered-devices/deactivate', data, successCallback, failCallback);
};

export const getOrganOfferRecipientsInitialValue = (data, successCallback, failCallback) => {
	post('/api/foedus/portlet/new-organ-offer/recipients/initial-values', data, successCallback, failCallback);
};

export const recreateFoedusPerson = (personId, successCallback, failCallback) => {
	put('/api/foedus/contacts/' + personId + '/recreate-cognito', null, successCallback, failCallback);
};

export const recreateTemporaryUser = (temporaryUserId, successCallback, failCallback) => {
	put('/api/foedus/contacts/temporary-users/' + temporaryUserId + '/recreate-cognito', null, successCallback, failCallback);
};
